import React from 'react';
import { Router, Redirect, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import {Login, Cambiarpass, Header, MenuMovil, Alerta, Footer} from './componentes/comun/Index';
import Index from './componentes/Index';
import Gestionar from './componentes/gestionar/Main';
import Rutas from './componentes/rutas/Main';
import Padron from './componentes/padron/Main';
import Configuraciones from './componentes/configuraciones/Main';
const menu = require('./assets/menu.json');

const history = createBrowserHistory({ basename: '/geo'});
const DISABLED = true; //modo desarrollo

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      showMenu:false,
      menuIzq:[]
    }
  }

  //backend en localhost o ministerio
  componentDidMount(){
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      localStorage.setItem('apiUrl', 'http://localhost:3001');
    } else {
      localStorage.setItem('apiUrl', 'https://mdh.tierradelfuego.gob.ar');
    }
  }

  //checkea nivel de acceso con session storage
  checkUser(nivel){
    const token = sessionStorage.getItem('token');
    const tipo = sessionStorage.getItem('tipo');
    if (token !== undefined){
      if (tipo === "2") {
        return true;
      } else if (tipo === "1") {
        if (nivel === 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  render(){
    const {showMenu,menuIzq} = this.state;
    return(
      <Router history={history} className="App">
        <Header
          history={history}
          menu={menu}
          abrirMenu={(izq) => this.setState({showMenu:!showMenu, menuIzq:izq})}
        />
        {showMenu &&
          <MenuMovil
            history={history}
            menuIzq={menuIzq}
            cerrarMenu={() => this.setState({showMenu:false})}
          />
        }
        {DISABLED &&                          // MENSAJE DE DESARROLLO
          <Alerta
            tipo="warning"
            mensaje="Sistema en desarrollo"
          />
        }
        <Switch>
          {/*
            <Route
              path="/ruta"                              //ruta
              component={(props) =>{
                  if (this.checkUser(1)) {              //checkea autorizacion
                    return (
                      <ruta
                        {...props}                      //manda al componente
                        history={history}
                      />
                    )
                  } else {
                    return(<Redirect to="/"/>)          //redirige al home
                  }
                }
              }
            />
          */}
          <Route
            path="/mis-rutas"                              //ruta
            component={(props) =>{
                if (this.checkUser(1)) {              //checkea autorizacion
                  return (
                    <Rutas {...props} history={history}/>
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/gestionar-rutas"                              //ruta
            component={(props) =>{
                if (this.checkUser(2)) {              //checkea autorizacion
                  return (
                    <Gestionar {...props} history={history}/>
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/padron"                              //ruta
            component={(props) =>{
                if (this.checkUser(2)) {              //checkea autorizacion
                  return (
                    <Padron {...props} history={history}/>
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/configuraciones"                              //ruta
            component={(props) =>{
                if (this.checkUser(2)) {              //checkea autorizacion
                  return (<Configuraciones {...props} history={history}/>)
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/login"
            component={(props) =>
              <Login history={history}/>
            }
          />
          <Route
            path="/cambiarpass"
            component={(props) =>
              <Cambiarpass history={history}/>
            }
          />
          <Route
            exact
            path="/"
            component={(props) =>
              <Index />
            }
          />
          <Route path="*">
            No encontrado
          </Route>
        </Switch>
        <Footer
          organismo="Ministerio de Desarrollo Humano"
          direccion="Güiraldes 576"
          codPostal="V9410BFR Ushuaia, Argentina"
          telefonos={[
            "+ 54 02901 441100"
          ]}
          redesSociales={{
            facebook:"https://www.facebook.com/MinDesarrolloHumanoTDF/",
            twitter:"https://twitter.com/GobiernoTDF/",
            instagram:"https://www.instagram.com/tierradelfuegogob/"
          }}
        />
      </Router>
    );
  }
}

export default App;
